import { useQuery } from "@tanstack/react-query";
import { AuthCard } from "@/components/AuthCard";
import { api } from "@/lib/api";
import { unwrap } from "@tern/api-client";

/** Development only: renders the `log` mailer's outbox with clickable links. */
export function DevOutboxPage() {
  const outbox = useQuery({
    queryKey: ["dev", "outbox"],
    queryFn: async () => unwrap(await api.GET("/api/dev/outbox")),
    refetchInterval: 3000,
  });

  return (
    <AuthCard title="Dev outbox" subtitle="Emails the server would have sent. Newest first, refreshes every 3s.">
      <ul className="flex flex-col gap-3">
        {outbox.data?.length === 0 && <li className="text-[13px] text-muted">No messages yet.</li>}
        {outbox.data?.map((m, i) => (
          <li key={i} className="rounded-lg border border-border bg-elevated p-3 text-[13px]">
            <div className="flex items-baseline justify-between gap-2">
              <span className="font-medium">{m.subject}</span>
              <span className="text-[11px] text-faint">{new Date(m.sent_at).toLocaleTimeString()}</span>
            </div>
            <div className="mt-0.5 text-[12px] text-muted">to {m.to}</div>
            <div className="mt-2 flex flex-col gap-1">
              {m.body.split(/\s+/).filter((w) => /^https?:\/\//.test(w)).map((url) => (
                <a key={url} href={url} className="btn btn-primary h-8 justify-center">
                  Open link
                </a>
              ))}
            </div>
          </li>
        ))}
      </ul>
    </AuthCard>
  );
}
